<template>
    <div class="container" @click="scrollToTop">
        <img src="@/assets/themeThree/top_btn.png" alt="">
    </div>
</template>

<script setup lang="ts">
const scrollToTop = () => {
    document.getElementById('top-of-home-page')?.scrollIntoView({ behavior: 'smooth' });
};

</script>
<style scoped>
.container {
    position: fixed;
    bottom: 65px;
    right: 15px;
    z-index: 1000; 
    cursor: pointer; 
}

.container img {
    border-radius: 10px;
    width: 50px;
    transition: transform 0.2s;
}

.container img:active {
    transform: scale(0.9);
}
</style>